import React from 'react';
import { PublicInactiveNotice } from '../../types/workspace';
import { WorkspaceProvider } from '../common/WorkspaceProvider';
import PromotionPublicContent from './PromotionPublicContent';

/** 404 안내 계약을 기존 고객 렌더러의 안전한 입력으로 연결한다. */
export default function InactivePublicContent({ notice, identifier }: { notice: PublicInactiveNotice; identifier: string }) {
  const promotion = notice.promotion || {
    id: '', title: notice.inactivePromotionTitle || '프로모션 종료', month: '', target: '', contact: '', slug: identifier, isActive: false,
  };
  return <WorkspaceProvider scope={{ mode: 'public', workspaceId: '', accountCode: '', publicIdentifier: identifier }}>
    <PromotionPublicContent promotion={promotion} systemSettings={notice} />
  </WorkspaceProvider>;
}
